import {
  getElementDescription,
  getElementQualifier,
  getElementTemperature,
  getLockedFieldsPath
} from "@/lib/ai/ai";
import { globalStore } from "@/store/store";
import { PromptInfo } from "../ai/types";
import { TreeNode } from "@/types/tree";

export function getPromptInfoFromNode(node: TreeNode): PromptInfo {

  const shouldGenerateOnInitialLoad = !!node.data.properties?.meta?.promptInfo?.singularity?.shouldGenerateOnInitialLoad;
  const sectionType = node.data.properties?.meta?.promptInfo?.singularity?.sectionData?.type ?? false;
  const sectionIndex = node.data.properties?.meta?.promptInfo?.singularity?.sectionData?.index ?? false;

  return {
    sectionDescription: getElementDescription(node),
    qualifiers: getElementQualifier(node),
    temperature: getElementTemperature(node),
    lockedFields: getLockedFieldsPath(node),
    locale: globalStore.aiSettings.locale,
    unsplash: {
      enabled: false,
      fillEmptyImagesOnly: false,
      keywords: ""
    },
    singularity: {
      shouldGenerateOnInitialLoad: shouldGenerateOnInitialLoad,
      sectionData: {
        type: sectionType,
        index: sectionIndex
      },
      unsplashKeywords: node.data.properties?.meta?.promptInfo?.singularity?.unsplashKeywords || []
    },
    onboarding: {
      shouldGenerateOnInitialLoad: shouldGenerateOnInitialLoad,
      sectionType: sectionType
    },

  };
}
